import { DateTime } from 'luxon';
import { fromJsonArray } from 'src/core/utils';
import ActionDTO from 'src/entities/basic-types/ActionDTO';
import AppointmentDto from 'src/entities/success-list/AppointmentDto';
import DirectCustomer from './DirectCustomer';

export type SuccessListEntryState = 'DECLINED' | 'OPEN' | 'PENDING' | 'REGISTERED_CUSTOMER' | 'REGISTERED_PARTNER';

export const ColorMapSuccessListEntryState: Record<SuccessListEntryState, ContextColor> = {
    DECLINED: 'error',
    OPEN: 'neutral',
    PENDING: 'warning',
    REGISTERED_CUSTOMER: 'success_light',
    REGISTERED_PARTNER: 'success_dark',
};

type ContactRelation = 'Partner' | 'Customer';

export type SuccessListEntryAction =
    | 'insertNote'
    | 'insertCall'
    | 'insertMeeting'
    | 'deleteEntry'
    | 'viewHistory'
    | 'setDecision'
    | 'editContact'
    | 'enablePotentialBusinessPartner'
    | 'enablePotentialLicensee'
    | 'enableLandingpage'
    | 'disableVideos'
    | 'POPUP_VIDEO_LIST';
export default class SuccessListEntry {
    public readonly nameListEntryId: string;
    public readonly ownerId?: number;
    public readonly firstName: string;
    public readonly lastName: string;
    public readonly salutation: string;
    public readonly dateOfBirth?: DateTime;
    public readonly email?: string;
    public readonly address?: string;
    public readonly candidateStatus: ContactRelation;
    public readonly familiarity: number;
    public readonly createdOn: DateTime;
    public readonly decision?: ContactRelation;
    public readonly decidedOn?: DateTime;
    public readonly suggestion?: ContactRelation;
    public readonly customerID: number; // TODO deprecated?
    public readonly note?: string;
    public readonly phoneNumber?: string;
    public readonly nameListAppointments: AppointmentDto[];
    public readonly possibleActions: ActionDTO<SuccessListEntryAction>[];
    public readonly state: SuccessListEntryState;
    public readonly countryIso2: string;
    public readonly customerDto?: DirectCustomer;
    public readonly videosEnabled: boolean;

    constructor(json: any) {
        this.nameListEntryId = json.nameListEntryId;
        this.ownerId = json.ownerId ? json.ownerId : undefined;
        this.firstName = json.firstName;
        this.lastName = json.lastName;
        this.salutation = json.salutation;
        this.dateOfBirth = json.dateOfBirth ? DateTime.fromISO(json.dateOfBirth) : undefined;
        this.email = json.email;
        this.address = json.address;
        this.candidateStatus = json.candidateStatus;
        this.familiarity = json.familiarity;
        this.createdOn = DateTime.fromISO(json.createdOn);
        this.decision = json.decision && json.decision !== 'None' ? json.decision : undefined;
        this.decidedOn = json.decidedOn ? DateTime.fromISO(json.decidedOn) : undefined;
        this.suggestion = json.suggestion && json.suggestion !== 'None' ? json.suggestion : undefined;
        this.customerID = json.customerID ? json.customerID : undefined;
        this.note = json.note ? json.note : undefined;
        this.phoneNumber = json.phoneNumber ? json.phoneNumber : undefined;
        this.nameListAppointments = fromJsonArray(AppointmentDto, json.nameListAppointments);
        this.possibleActions = fromJsonArray<ActionDTO<SuccessListEntryAction>>(ActionDTO, json.possibleActions);
        this.state = json.state;
        this.countryIso2 = json.countryIso2;
        this.customerDto = json.customerDto ? new DirectCustomer(json.customerDto) : undefined;
        this.videosEnabled = json.videosEnabled ?? false;
    }

    public getNextAction(): AppointmentDto | undefined {
        return this.nameListAppointments
            .filter(dto => dto.tookPlaceOn == null)
            .filter(dto => dto.appointmentDate != null)
            .sort((a, b) => {
                return a.appointmentDate!.toMillis() - b.appointmentDate!.toMillis();
            })[0];
    }

    public get name(): string {
        return `${this.firstName} ${this.lastName}`;
    }
}
